/**
 * Files for the open workspace (core DriveViewModel), provided by the app shell next to WorkspaceContext. The sidebar,
 * the Files screen and its dialogs share it. Native: an `@Environment` value / `CompositionLocal` with the same model.
 */
import type { DriveViewModel, DriveViewState } from "@bundle/core";
import { createContext, useContext, useSyncExternalStore } from "react";

export const DriveContext = createContext<DriveViewModel | null>(null);

const noopSubscribe = () => () => {};
const none = (): null => null;

/** The Files view model and state (null outside a workspace). */
export function useDrive(): { vm: DriveViewModel; state: DriveViewState } | null {
  const vm = useContext(DriveContext);
  const state = useSyncExternalStore(vm?.subscribe ?? noopSubscribe, vm?.getSnapshot ?? none, vm?.getSnapshot ?? none);
  return vm === null || state === null ? null : { vm, state };
}
